/**
 * 사용자 테이블 아이템 형태 정의
 * 서버 응답을 테이블에서 사용할 수 있는 형태로 변환하기 위한 구조 정의
 */

/**
 * 테이블에서 사용하는 사용자 아이템의 필드 구조
 */
export const USER_TABLE_ITEM_SCHEMA = Object.freeze({
  seq: null,                   // number - 사용자 시퀀스
  userId: null,                // string - 사용자 ID
  name: null,                  // string - 사용자명
  companySeq: null,            // number - 회사 시퀀스
  companyName: null,           // string - 회사명
  userImagePath: null,         // string - 사용자 이미지 경로
  userRole: null,              // string - 사용자 역할
  userStatus: null             // string - 사용자 상태
});

/**
 * 서버 응답 데이터를 테이블 아이템 형태로 변환하는 함수
 * @param {Object} serverItem - 서버에서 받은 사용자 객체
 * @returns {Object} 테이블에서 사용할 수 있는 형태의 아이템 객체
 */
export function transformToUserTableItem(serverItem) {
  if (!serverItem) {
    return null;
  }

  return {
    seq: serverItem?.seq ?? null,
    userId: serverItem?.userId ?? null,
    name: serverItem?.name ?? null,
    companySeq: serverItem?.companySeq ?? null,
    companyName: serverItem?.companyName ?? null,
    userImagePath: serverItem?.userImagePath ?? null,
    userRole: serverItem?.userRole ?? null,
    userStatus: serverItem?.userStatus ?? null
  };
}

/**
 * 서버 응답 배열을 테이블 아이템 배열로 일괄 변환하는 함수
 * @param {Array<Object>} serverItems - 서버에서 받은 사용자 객체 배열
 * @returns {Array<Object>} 테이블에서 사용할 수 있는 형태의 아이템 객체 배열
 */
export function transformToUserTableItems(serverItems) {
  if (!Array.isArray(serverItems)) {
    return [];
  }

  return serverItems
    .map(item => transformToUserTableItem(item))
    .filter(item => item !== null);
}

